export const ROUTE_HOME = '/'
export const ROUTE_CREATOR_TXT2IMG = '/creator/txt2img'
export const ROUTE_CREATOR_IMG2IMG = '/creator/img2img'
export const ROUTE_CREATOR_REFINE = '/creator/refine'
export const ROUTE_GALLERY = '/gallery'
export const ROUTE_TRAINING = '/training'
export const ROUTE_TUTORIAL = '/tutorial'
